/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![AirplayIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAC/0lEQVR4nMVVSWtUQRAecMcNUXFHXI9evKiXUSQ4OFPLC/RUzUQdQYm/ILjgTuLJ3PWsJ1FRBJeDenTBXUQFl6PiwS1uCIlS73XP9BDjJCDY0PC6u7qqvq++6pfL/c9RKHRMAZZOJD2DJC+R5Us6s+/TdmY2I3bsnBsLJAeB5QOy/vr7lPfIst/uDMv5xvbqQiS97R0MIOnFEsnmYnt1cb5WG2+TWZYglrcAy+UQCEhu2d2/Oi8W3TxgfZ1eYH0CSXlVq4RKXFmNJE99oFeIOndIWpDlYWpIctU5N8n2k6RjDrL2IOljIP2WTpZHQNq90bnZZoOIk4H1epaY3Ovs7BwzKACy7g2Zh8IBaxlIPw7Fv52ZjdnanYAESPY0O88y+GycG+R0LykrkPRniPQCYnmdc26qOSKStcBy3jvrx0Sc3SGSNWndWD4FBtJBVNnhqbkUaPEBfw3KJhpAstMr6ROAzkoTI71ie0SV7Q0EpnMzTMod2VqOhMxzuVwun8+PNilm+tdXQLLPOTfK3z3nKTvsaa35u6camQTlgFuUreVRloWs9fXp+QP/3V5FeV/c+6kS2yvLgqIiqNpnm5apR/Dd1oFHJH2HpDdM/wBuKbDcRJa3dtbWtmmiD9iXoq3VxgfaYgX9sM0gL2T9GgcA0kPOuQmRpCcg64EgkDhAoVAY5xF8jRG8iClC0ge2LpGsb1JbokWbTYVOtM1TdCddg1vq5f4sqoGXHOsmj+Cwh9nVcF6X7YA9Ew300uXVdjAuMrCcjeW2LZZpqVSZgSxHiWRBRkN5XaDRO/tJVN7gJT3fbJk3T49lCiRb6wGKxeo0X+h6o9WDg674UzdbnzBXV8a2odHszJoyPjNouz2KE/XA7dXFSPpmyKea9B2zLI9qedJTu6vJeZAXsBwL0AvOzQTS5y3/ByQvw6MHiRaQ9bj5GhSgSS0mPdK7rX829Z/Ow0GUDDWsF+IfCQ5zAus164GWAYC0d6TOsfF89LYMYD1Qf6ZH5Fz6reOHRdO/HL8BPGE+jh9ssY0AAAAASUVORK5CYII=)
 */
export const AirplayIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 3a9 9 0 0 0-7.47 14.03c.28.41.28.97-.06 1.35-.4.45-1.12.44-1.47-.05a11 11 0 1 1 18 0c-.35.5-1.06.5-1.47.05a1.1 1.1 0 0 1-.06-1.35A9 9 0 0 0 12 3Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M18.25 15.15c-.3.58-1.07.62-1.5.13a1.2 1.2 0 0 1-.16-1.29A4.98 4.98 0 0 0 12 7a5 5 0 0 0-4.59 7c.19.42.16.93-.15 1.28-.44.49-1.22.45-1.51-.13a7 7 0 1 1 12.5 0Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M14.99 12.3c-.04.38-.5.47-.76.19a3.05 3.05 0 0 0-.25-.25l-.3-.27c-.5-.46-1.04-.97-1.68-.97-.64 0-1.19.5-1.68.97l-.3.27-.25.25c-.26.28-.72.2-.76-.19L9 12a3 3 0 1 1 5.99.3ZM12.74 13.83a1 1 0 0 0-1.48 0l-6.76 7.5A1 1 0 0 0 5.25 23h13.5a1 1 0 0 0 .75-1.67l-6.76-7.5Z"
        className={colorClass}
      />
    </svg>
  );
};
